<div class="row" [@.disabled]="expandAll">

    <div [class]="columnClasses()">
        @if (plan?.plan_timelines && plan.plan_timelines.length) {
        <h2 class="column-header">TIMELINE</h2>
        <table class="table table-borderless definitions w-100">
            @for (timepoint of plan.plan_timelines; track timepoint) {

            <tr>
                <td>
                    {{ timepoint.event}}
                    @if (timepoint.description.length > 5) {
                    ({{ timepoint.description | stripTags }})
                    }
                </td>
                <td class="ps-2">{{ timepoint.date_of_timeline_display | date}}</td>
            </tr>

            }
        </table>
    }
        @if (plan.mips && plan.mips.length) {
        <h2 class="column-header">
            MIP
        </h2>
        <table class="table w-100">
            <thead>
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Amount</th>
                    <th>Reorg Entity</th>
                </tr>
            </thead>
            <tbody>
                @for (mip of plan.mips; track mip) {

                <tr>
                    <td class="row-toggle" (click)="isExpanded[mip.mip_name] = ! isExpanded[mip.mip_name]">
                        <i-bs [name]="iconNames.ChevronDown" [@openClose]="isExpanded[mip.mip_name] ? 'open' : 'closed'" class="d-inline-block"></i-bs>
                    </td>
                    <td>{{ mip.mip_name }}</td>
                    <td>
                        @if (mip.mip_reserved_amount_percent.length > 0) {

                        {{ mip.mip_reserved_amount_percent }}%

                        } @else if (mip.mip_reserved_amount_dollar > 0) {

                        ${{ mip.mip_reserved_amount_dollar }}

                        } @else if (mip.mip_reserved_amount_percent.length == 0 && mip.mip_reserved_amount_dollar.length == 0) {

                        N/A

                        }
                    </td>
                    <td>
                        <ul class="list-unstyled mb-0">
                            @if (mip.linked_instrument_id.isArray) {
                            @for (id of mip.linked_instrument_id; track id) {
                            <li>
                                <a (click)="openInstrument($event, situationID, id)">{{ instrumentIDLookup[id] }}</a>
                            </li>
                            }
                            }

                            @if (!mip.linked_instrument_id.isArray && mip.linked_instrument_id.length > 0) {
                            <li>
                                <a (click)="openInstrument($event, situationID, mip.linked_instrument_id)">{{ instrumentIDLookup[mip.linked_instrument_id] }}</a>
                            </li>
                            }
                        </ul>
                    </td>


                </tr>
                @if (isExpanded[mip.mip_name]) {
                <tr @expandCollapse>
                    <td colspan="100">
                        <div class="collapsible d-block">
                    <td colspan="4" [innerHTML]="mip.mip_vesting_note"></td>
    </div>
    </td>
    </tr>
    }
    }
    </tbody>
    </table>

    }
    @if (plan.sources_of_plan_distributions && plan.sources_of_plan_distributions.length > 12) {

    <h2 class="column-header">
        SOURCES OF PLAN DISTRIBUTIONS
    </h2>
    <div [innerHTML]="plan.sources_of_plan_distributions"></div>

    }
</div>


@if (plan.plan_features_with_notes && plan.plan_features_with_notes.length) {
<div [class]="columnClasses()">
    <h2 class="column-header">
        PLAN FEATURES
    </h2>
    <table class="table table-borderless definitions w-100 one-line-first-column">
        <thead>
            <tr>
                <th>Features</th>
                <th>Notes</th>
            </tr>
        </thead>
        <tbody>
            @for (feature of plan.plan_features_with_notes; track feature) {

            <tr>
                <td>{{ feature.claim_type }}</td>
                <td [innerHTML]="feature.notes"></td>
            </tr>

            }
        </tbody>
    </table>
</div>
}
@if (plan.plan_parties && plan.plan_parties.length) {
<div [class]="columnClasses()">
    <h2 class="column-header">
        PLAN PARTIES
    </h2>
    <table class="table table-borderless definitions w-100">
        <tbody>
            @for (party of plan.plan_parties; track party) {

            <tr>
                <td>{{ party.plan_role }}</td>
                <td><a href="/organizations/{{party.company_id}}">{{ party.company_name }}</a></td>
            </tr>

            }
        </tbody>
    </table>
</div>
}


<ng-container *ngTemplateOutlet="terms_table; context: {$implicit: plan.key_defined_terms, title: 'KEY DEFINED TERMS'}"></ng-container>
<ng-container *ngTemplateOutlet="terms_table; context: {$implicit: plan.release_terms, title: 'RELEASE RELATED TERMS'}"></ng-container>



<plan-treatment-unclassified [plan_classes_unclassifieds]="plan.plan_classes_unclassifieds" [situationID]="situationID" [instrumentIDLookup]="instrumentIDLookup" [classesLookup]="classesLookup" [showMatches]="showMatches"
    [treatmentColumnVisibility]="treatmentColumnVisibility" class="col-12"></plan-treatment-unclassified>
<plan-treatment-classified [plan_classes_classified]="plan.plan_classes_classified" [situationID]="situationID" [instrumentIDLookup]="instrumentIDLookup" [classesLookup]="classesLookup" [showMatches]="showMatches"
    [treatmentColumnVisibility]="treatmentColumnVisibility" class="col-12"></plan-treatment-classified>
<court-documents [documents]="plan.dockets" colsDefn="col-12"></court-documents>
</div>


<ng-template #terms_table let-terms let-title="title">
    @if (terms && terms.length) {
    <div class="col-12 my-2">
        <h2 class="column-header">
            {{ title }}
        </h2>
        <table class="table table-borderless definitions w-100">
            <tbody>
                @for (term of terms; track term) {

                <tr>
                    <td style="width: 15%">{{ term.term }}</td>
                    <td [innerHTML]="term.description"></td>
                </tr>

                }
            </tbody>
        </table>
    </div>
    }
</ng-template>
<ng-template #exact_min_max_currency let-exact="exact" let-min="min" let-max="max">
    @if ((exact + min + max).trim().length === 0) {

    N/A

    } @else {

    @if (exact.length > 0) {

    {{ exact | currency }}

    } @else {

    @if (min.length > 0 && max.length > 0) {

    {{ min | currency }} - {{ max | currency }}

    } @else {

    @if (min.length > 0) {

    &gt;{{ min | currency }}
    } @else {

    @if (max.length > 0) {

    &lt;{{ max | currency }}

    }

    }

    }

    }

    }
</ng-template>

<ng-template #exact_min_max_percentage let-exact="exact" let-min="min" let-max="max">
    @if ((exact + min + max).trim().length === 0) {

    N/A

    } @else {

    @if (exact.length > 0) {

    {{ exact }}%

    } @else {

    @if (min.length > 0 && max.length > 0) {

    {{ min }} - {{ max }}%

    } @else {

    @if (min.length > 0) {

    &gt;{{ min }}%

    } @else {

    @if (max > 0) {

    &lt;{{ max }}%

    }

    }

    }

    }

    }
</ng-template>

<ng-template #claims_table let-class>
    @if (class.allowed_claims_individual.length) {
    <div class="col-12 my-2">
        <table cdk-table [dataSource]="class.allowed_claims_individual" class="table table-borderless definitions w-100" >
            <ng-container cdkColumnDef="claim_type">
                <th cdk-header-cell *cdkHeaderCellDef> Claim type </th>
                <td cdk-cell *cdkCellDef="let claim" class="plain">
                    {{claim.claim_type}}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="instruments_dips">
                <th cdk-header-cell *cdkHeaderCellDef>Pre-petition Instruments </th>
                <td cdk-cell *cdkCellDef="let claim" class="pr-2">
                    <ul class="list-unstyled">
                        @for (id of claim.instruments_dips; track id) {
                        <li>
                            <a (click)="openInstrument($event, situationID, id)">{{ instrumentIDLookup[id] }}</a>
                        </li>
                        }
                    </ul>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="allowed_claims">
                <th cdk-header-cell *cdkHeaderCellDef> Allowed Claims </th>
                <td cdk-cell *cdkCellDef="let party" class="pr-2">
                    <ng-container *ngTemplateOutlet="exact_min_max_currency; context: {exact: class.allowed_claims_exact, min: class.allowed_claims_min, max: class.allowed_claims_max}"></ng-container>
                </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="getNonEmptyColumns(class.allowed_claims_individual)"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: getNonEmptyColumns(class.allowed_claims_individual)"></tr>
        </table>
    </div>
    }
</ng-template>

<ng-template #treatments_table let-class>
    @if (class.toggle_treatments.length) {
    <div class="col-12 my-2">
        <h2 class="column-header">
            TREATMENTS
        </h2>
        <table class="table definitions">
            <thead>
                <tr>
                    <th class="pr-1 border-top-0">Claim/Interest</th>
                    <th class="text-center px-1 text-nowrap border-top-0">Option #</th>
                    @if (class.columnVisibility['treatment_gift']) {
                    <th class="text-center px-1 border-top-0">Recovery&nbsp;Consideration</th>
                    }
                    @if (class.columnVisibility['linked_instrument_id']) {
                    <th class="px-1 border-top-0">Post-petition Instrument</th>
                    }
                    @if (class.columnVisibility['Other']) {
                    <th class="px-1 border-top-0">CVRs/Trust Interest/Other Consideration</th>
                    }
                    @if (class.columnVisibility['received_dollar'] || class.columnVisibility['received_percent']) {
                    <th class="px-1 border-top-0 text-nowrap">%/$ Received</th>
                    }
                    @if (class.columnVisibility['notes'] || class.columnVisibility['recovery_amount_other']) {
                    <th class="pl-1 border-top-0">Notes</th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (treatmentrow of class.toggle_treatments; track treatmentrow) {

                @for (treatmentGroup of treatmentrow.groupedTreatments; track treatmentGroup; let claimIndex = $index) {

                @for (treatment of treatmentGroup; track treatment; let treatmentIndex = $index) {

                <tr>
                    @if (claimIndex == 0 && treatmentIndex == 0) {
                    <td class="pr-1" [attr.rowspan]="treatmentrow.count">{{ treatmentrow.treatment_name }}</td>
                    }
                    @if (treatmentIndex == 0) {
                    <td class="plain px-1 text-center" [attr.rowspan]="treatmentGroup.length">{{ treatment.option_number }}</td>
                    }
                    <td class="plain px-1 text-center">{{treatment.treatment_gift}} </td>
                    @if (class.columnVisibility['linked_instrument_id']) {
                    <td class="px-1">

                        <a (click)="openInstrument($event, situationID, treatment.linked_instrument_id)" class="a_without_href">{{instrumentIDLookup[treatment.linked_instrument_id]}}</a>
                    </td>
                    }
                    @if (class.columnVisibility['Other']) {
                    <td class="px-1" [innerHTML]="treatment.Other">
                    </td>
                    }
                    @if (class.columnVisibility['received_dollar'] || class.columnVisibility['received_percent']) {
                    <td class="px-1">
                        @if (treatment.received_dollar > 0) {
                        {{treatment.received_dollar | currency}}
                        }
                        @if (treatment.received_percent > 0) {
                        {{treatment.received_percent}}%
                        }
                    </td>
                    }
                    @if (class.columnVisibility['notes'] || class.columnVisibility['recovery_amount_other']) {
                    <td class="ps-2" [innerHTML]="treatment.notes"></td>
                    }
                </tr>

                }

                }

                }
            </tbody>
        </table>
    </div>
    }
</ng-template>